import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useCallback, useState } from 'react';

const useGetDefaultCodingProfile = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [codingProfile, setCodingProfile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [failed, setFailed] = useState(false);

  const getDefaultCodingProfile = useCallback(() => {
    setLoading(true);
    setFailed(false);

    return axiosClient
      .get('SettingProduct/CoddingProfile/GetDefault')
      .then(res => {
        if (res.status === 200 && res.data?.result && res.data?.value) {
          setCodingProfile(res.data.value ?? null);
          return res.data.value ?? null;
        }

        setFailed(true);
        enqueueSnackbar(
          res.data?.message ?? 'دریافت پروفایل پیش‌فرض ناموفق بود.',
          {
            variant: 'error',
          },
        );
        return null;
      })
      .catch(() => {
        setFailed(true);
        enqueueSnackbar('خطایی در برقراری ارتباط رخ داد.', {
          variant: 'error',
        });
        return null;
      })
      .finally(() => setLoading(false));
  }, [enqueueSnackbar]);

  return { getDefaultCodingProfile, codingProfile, loading, failed };
};

export default useGetDefaultCodingProfile;
